import React, { useState } from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'

import Layout from '../../components/layout'
import Meta from '../../components/meta'
import { graphql } from 'gatsby'
import axios from 'axios'
import qs from 'qs'
import filterLocale from '../../components/utils/filter-locale'
import SupportSearch from '../../components/support/support-search'
import Tabs from '../../components/support/tabs'
import {
	ListboxInput,
	ListboxButton,
	ListboxPopover,
	ListboxList,
	ListboxOption,
} from '@reach/listbox'
import '@reach/listbox/styles.css'
import {
	StyledForm,
	HomeButtonRow,
	HomeButton,
} from '../../components/form/styles'
import { Formik } from 'formik'
import assign from 'lodash.assign'
import {
	flat,
	validationSwitch,
	validationSchema,
} from '../../components/form/utils'
import FormFieldGroup from '../../components/form/FormFieldGroup'
import FormFieldSingle from '../../components/form/FormFieldSingle'
import * as Yup from 'yup'
import moment from 'moment'
import PopUp from '../../components/modal/forms'
import localeCheck from '../../components/utils/locale-check'

const ContentsSection = tw.section`w-full bg-gray-200`
const ContentsContainer = tw.div`w-95 md:w-11/12 bg-white py-10 px-4 md:px-10 mx-auto border-l border-r border-gray-300 border-b rounded-b-lg mb-16`

const TextsContainer = tw.div`flex flex-col mb-10`
const RegistrationHeader = tw.h2`font-display text-3xl md:text-4xl font-bold mb-6`
const RegistrationText = styled.p`
	${tw`font-display text-base md:text-lg`}
`
const Popover = styled(ListboxPopover)`
	${tw`font-display text-sm`}
	z-index: 100;
`
const SelectBoxContainer = styled.div`
	[data-reach-listbox-button] {
		${tw`py-3 rounded px-4 font-display mb-8`}
	}
`

const LowerTextContainer = styled(TextsContainer)`
	${tw`mb-0 mt-10`}
`
const LowerTextHeader = styled(RegistrationHeader)``
const LowerTextSubText = styled(RegistrationText)``
const LowerTextList = tw.ul`my-8`
const LowerTextListItem = tw.li`my-2 ml-2`

const ResultContainer = styled.div`
	> form {
		${tw`mx-auto`}
	}
`
const DolphinLink = tw.a`font-display underline text-blue-600 hover:no-underline hover:text-blue-500`

const Registration = ({ data: { productregistration, prodregister } }) => {
	const [showPopUp, setShowPopUp] = React.useState(false)
	const openPopUp = () => setShowPopUp(true)
	const closePopUp = () => setShowPopUp(false)
	const [value, setValue] = useState('default')
	const locale = 'en-ZA'
	const [{ node }] = filterLocale(productregistration.edges, locale)

	const { seoTitle, seoKeywords, seoDescription } = node

	const [{ node: nodeRegister }] = filterLocale(prodregister.edges, locale)
	const { items: registrationItems } = nodeRegister

	const valuesMapped = flat(registrationItems).map(item => ({
		[item.inputName]: '',
	}))
	const validationMapped = flat(registrationItems).map(item => ({
		[item.inputName]: validationSwitch(item.inputName, item.validationText),
	}))
	/** New Object from mapped Array */
	const valuesObject = assign({}, ...valuesMapped)
	const validationObject = assign(
		{},
		...validationMapped,
		{
			purchasedate: Yup.date()
				.max(
					moment()
						.add(0, 'days')
						.format('YYYY-MM-DD'),
					'Cannot go over the date today'
				)
				.required('date is required'),
		},
		{
			purchaseplace: Yup.string()
				.min(2, 'Too Short!')
				.max(50, 'Too Long!')
				.required(`Required`),
		},
		{
			serialnumber: Yup.string()
				.min(2, 'Too Short!')
				.max(12, 'Too Long!')
				.required(`Required`),
		}
	)

	const brandArray = ['Dolphin']

	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
				lang={locale}
			/>
			<SupportSearch />
			<Tabs locale={locale} />
			<ContentsSection>
				<ContentsContainer>
					<TextsContainer>
						<RegistrationHeader>
							Maytronics Warranty Registration
						</RegistrationHeader>
						<RegistrationText>
							This is the place where we can register your product and help you
							get the very best from your Maytronics product through its whole
							lifetime. Failure to register your product will not diminish your
							warranty rights. Please keep your proof of purchase.
						</RegistrationText>
					</TextsContainer>

					<SelectBoxContainer>
						<ListboxInput
							value={value}
							onChange={value => {
								setValue(value)
							}}
						>
							<ListboxButton arrow="▼" />
							<Popover>
								<ListboxList>
									<ListboxOption value="default">Select Brand</ListboxOption>
									{brandArray.map((brand, i) => {
										return (
											<ListboxOption key={i} value={brand}>
												{brand}
											</ListboxOption>
										)
									})}
								</ListboxList>
							</Popover>
						</ListboxInput>
					</SelectBoxContainer>

					<ResultContainer>
						{value === 'Dolphin' ? (
							<DolphinLink
								href="https://registration.maytronics.com/"
								target="_blank"
							>
								https://registration.maytronics.com/
							</DolphinLink>
						) : (
							''
						)}
						{/* {value === 'Mineral Swim' || value === 'Ozone Swim' ? (
							<Formik
								initialValues={valuesObject}
								validationSchema={validationSchema(validationObject)}
								onSubmit={async (values, { setSubmitting, resetForm }) => {
									setSubmitting(true)
									const url =
										'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
									const body = {
										origin: 'Contact Us WebSite',
										orgid: '00D58000000JkgU',
										retURL:
											'https://maytronics.com.au/support/register/?form=register',
										subject: 'Mineral Swim - Register',
										'00N4H00000E2wq9':
											'https://maytronics.com.au/support/register',
										recordType: '0124H0000006NyI',
										name: `${values.firstName} ${values.lastName}`,
										email: values.email,
										phone: values.phone,
										'00N4H00000E2wqB': values.streetAddress,
										'00N4H00000E2wq6': values.city,
										'00N4H00000E2wqA': values.state,
										'00N4H00000E2wqC': values.postCode,
										'00N4H00000E2wq7': 'Australia',
										'00N4H00000EBmOC': values.purchasedate,
										company: values.purchaseplace,
										'00N5800000Du5Hs': values.serialnumber,
									}
									axios.post(url, qs.stringify(body))
									axios.post('/.netlify/functions/graphql', {
										query: `
											mutation createForm(
												$formName: String!
												$firstName: String
												$lastName: String
												$company: String
												$email: String
												$phone: String
												$address: AddressInput
											) {
												createForm(
													formName: $formName
													firstName: $firstName
													lastName: $lastName
													company: $company
													email: $email
													phone: $phone
													address: $address
												) {
													_id
												}
											}
                    `,
										variables: {
											formName: 'register',
											firstName: values.firstName,
											lastName: values.lastName,
											company: values.purchaseplace,
											email: values.email,
											phone: values.phone,
											address: {
												line1: values.streetAddress,
												city: values.city,
												state: values.state,
												postalCode: values.postCode,
												country: `Australia`,
											},
										},
									})
									resetForm()
									setSubmitting(false)
									return openPopUp()
								}}
							>
								{({ isSubmitting, errors, touched, values }) => (
									<StyledForm>
										{registrationItems.map((item, index) => {
											if (item.items) {
												const { title, items } = item
												return (
													<FormFieldGroup
														key={title + index}
														// color="#fff"
														{...{ items, errors, touched, values }}
													/>
												)
											} else {
												return (
													<FormFieldSingle
														key={item.inputName + index}
														overrideWidth="full"
														// color="#fff"
														{...{
															item: { ...item, helpText: null },
															errors,
															touched,
															values,
														}}
													/>
												)
											}
										})}
										<HomeButtonRow>
											<HomeButton type="submit" disabled={isSubmitting}>
												REGISTER
											</HomeButton>
										</HomeButtonRow>
									</StyledForm>
								)}
							</Formik>
						) : (
							''
						)} */}
						<PopUp showDialog={showPopUp} close={closePopUp} />
					</ResultContainer>

					<LowerTextContainer>
						<LowerTextHeader>Why Register? More perks.</LowerTextHeader>
						<LowerTextSubText>
							Being a Maytronics product registered owner has even more perks:
						</LowerTextSubText>
						<LowerTextList>
							<LowerTextListItem>- Exclusive deals</LowerTextListItem>
							<LowerTextListItem>- Free Health Check</LowerTextListItem>
							<LowerTextListItem>- First to know</LowerTextListItem>
						</LowerTextList>
						<LowerTextSubText>
							We don’t stop caring about our machines once they’re yours.
							Registering your product allows us to give you a tailored,
							complimentary, direct service for your machine. Even after your
							warranty has ended, we’ll still be on hand to help.
						</LowerTextSubText>
					</LowerTextContainer>
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}

export const supportFaqQuery = graphql`
	query productRegistrationQueryZa {
		productregistration: allContentfulPage(
			filter: { contentful_id: { eq: "2F8kwuaezbHlGda1m1fPIG" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		prodregister: allContentfulForm(
			filter: { contentful_id: { eq: "3Hww3i0rwUK8T3Nf7idd6l" } }
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
	}
`

Registration.propTypes = {
	data: PropTypes.objectOf({
		productregistration: PropTypes.any,
		prodregister: PropTypes.any,
	}),
}

export default Registration
